// @spec GHG-STR-016
'use client';

import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { CommutingSurveyList } from '@/features/ghg/commuting-surveys/components';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/ghg/commuting-surveys/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.commutingSurveys'),
  }),
  component: CommutingSurveysPage,
});

/**
 * Commuting Surveys list page.
 *
 * Displays all employee commuting surveys with status indicators
 * and response rates. Allows GHG Managers to create new surveys
 * and manage existing ones.
 */
function CommutingSurveysPage() {
  const { t } = useTranslation('ghg');
  const navigate = useNavigate();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-6xl space-y-8">
        {/* Header */}
        <header className="flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">{t('commutingSurveysPage.heading')}</h1>
            <p className="mt-1 text-muted-foreground">
              {t('commutingSurveysPage.description')}
            </p>
          </div>
          <Button asChild>
            <Link to="/ghg/commuting-surveys/new">
              <Plus className="mr-2 h-4 w-4" />
              {t('commutingSurveysPage.createSurvey')}
            </Link>
          </Button>
        </header>

        {/* Survey List */}
        <CommutingSurveyList
          onViewClick={(survey) => {
            void navigate({
              to: '/ghg/commuting-surveys/$surveyId',
              params: { surveyId: survey.id },
            });
          }}
        />
      </div>
    </div>
  );
}
